// extracted by mini-css-extract-plugin
module.exports = {"timeTit":"Timer--timeTit--33FLmhC"};